"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 *
 */
function NewIcon() {
    return ((0, jsx_runtime_1.jsxs)("svg", { width: "26", height: "12", viewBox: "0 0 26 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("rect", { width: "26", height: "12", rx: "6", fill: "#0FADFF" }), (0, jsx_runtime_1.jsx)("path", { d: "M4.00903 9H5.44903V5.408L7.53703 9H9.12103V3.28H7.68903V6.504L5.85703 3.28H4.00903V9ZM10.2278 9H14.3078V7.736H11.8598V6.696H13.7078V5.528H11.8598V4.544H14.1798V3.28H10.2278V9ZM16.0142 9H17.6142L18.5022 5.368L19.3822 9H21.0942L22.4302 3.28H20.9102L20.1342 6.88L19.3022 3.28H17.8462L17.0782 6.848L16.3422 3.28H14.6862L16.0142 9Z", fill: "white" })] }));
}
exports.NewIcon = NewIcon;
//# sourceMappingURL=NewIcon.js.map